module.exports = __webpack_public_path__ + "static/osinaike-fc5401d8701004eb7478a0fa025b4122.jpg";